// @flow
import { RESORT_ACCESS_AND_MAP } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_ACCESS_AND_MAP } from 'Utils/request/requestDictionary';

type CMSProps = {|
  accessTitle: string,
  mapType: 'GOOGLE' | 'BAIDU',
  minutes: string,
  resortId: string,
  title: string,
|};

export const productAccessAndMapResolver = {
  name: RESORT_ACCESS_AND_MAP,
  resolve: (appContext: AppContext, { resortId }: CMSProps) => {
    const query = `query {
      config {
        common {
          close
          loadLess
          maps {
            productBaiduMap
            productGoogleMap
            productGoogleStreetView
          }
          viewMore
        }
      }
      resort(resortId: "${resortId}") {
        name
        address {
          streetNumber
          streetName
          additionalInformation1
          additionalInformation2
          addOn
          city
          town
          zipCode
          stateOrDistrict
          country
        }
        coordinates {
          latitude
          longitude
        }
        accesses {
          id
          type
          name
          transfertDurationMin
        }
        streetView {
          latitude
          longitude
          heading
          pitch
          fov
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_ACCESS_AND_MAP,
      strictErrors: false,
    });
  },
};
